import { render, staticRenderFns } from "./LeaveQueue.vue?vue&type=template&id=42b76df4"
import script from "./LeaveQueue.vue?vue&type=script&lang=js"
export * from "./LeaveQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports